<template>
  <div class="checker-results">
    <div class="half">
      <h3>Owner</h3>
      <div>{{ owner }}</div>
    </div>
    <div class="half">
      <h3>Licence Number</h3>
      <div>{{ licenceNumber }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
     <h3>Expiry</h3>
      <div>{{ expiry }}</div>
    </div>
    <div class="half">
      <h3>Provisional</h3>
      <div>{{ provisional }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
      <h3>Visual Aids</h3>
      <div>{{ visualAids }}</div>
    </div>
    <div class="half">
      <h3>PWC Endorsement</h3>
      <div>{{ pwcEndorsement }}</div>
    </div>
  </div>
</template>
<script>
import { bool, date, title } from '@/filters'
export default {
  props: {
    item: { type: Object, default: () => {} }
  },
  computed: {
    licenceNumber () { return this.item.key },
    expiry () { return date(this.item.expiry_date) },
    owner () { return title(this.item.owner.full_name) },
    visualAids () { return title(bool(this.item.has_visual_aids)) },
    pwcEndorsement () { return title(bool(this.item.has_pwc_endorsement)) },
    provisional () { return title(bool(this.item.is_provisional)) }
  },
  mounted () {
    if (window.__gaTracker) {
      window.__gaTracker('send', 'event', 'Licence Checker', 'Motor Boat Licence Check')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/licence-results.vue